import { FormField } from '../types/FormField';

export const formConfig: FormField[] = [
  { name: 'email', type: 'text', size: 'm', label: 'Email *', required: true },
  { name: 'phone', type: 'tel', size: 'm', label: 'Телефон', required: false },
  { name: 'message', type: 'text', size: 'm', label: 'Сообщение *', required: true },
];
